module.exports = __webpack_public_path__ + "img/norCopy.e1b5cb51.png";